"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _grid = _interopRequireDefault(require("cccisd-icons/grid3"));
var _menu = _interopRequireDefault(require("cccisd-icons/menu7"));
var _folderPlus = _interopRequireDefault(require("cccisd-icons/folder-plus"));
var _filePlus = _interopRequireDefault(require("cccisd-icons/file-plus"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _info = _interopRequireDefault(require("cccisd-icons/info"));
var _fileUpload = _interopRequireDefault(require("cccisd-icons/file-upload"));
var _mic = _interopRequireDefault(require("cccisd-icons/mic2"));
var _search = _interopRequireDefault(require("cccisd-icons/svg/search2"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _assets = require("../../reducers/assets.js");
var _assets2 = require("../../selectors/assets.js");
var _reactRedux = require("react-redux");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _AddFolderForm = _interopRequireDefault(require("./AddFolderForm"));
var _GenerateSpeechForm = _interopRequireDefault(require("./GenerateSpeechForm"));
var _RenameFolderForm = _interopRequireDefault(require("./RenameFolderForm"));
var _RenameFileForm = _interopRequireDefault(require("./RenameFileForm"));
var _MoveForm = _interopRequireDefault(require("./MoveForm"));
var _FileInfo = _interopRequireDefault(require("./FileInfo"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false
    });
    _defineProperty(_assertThisInitialized(_this), "setViewMode", function (mode, e) {
      e && e.preventDefault();
      _this.props.setViewMode(mode);
    });
    _defineProperty(_assertThisInitialized(_this), "setSortBy", function (e) {
      _this.props.setSortBy(e.target.value);
    });
    _defineProperty(_assertThisInitialized(_this), "onFilterKeyDown", function (e) {
      e.nativeEvent.stopImmediatePropagation();
    });
    _defineProperty(_assertThisInitialized(_this), "setFilter", function (e) {
      _this.props.setFilter(e.target.value);
    });
    return _this;
  }
  _createClass(Component, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isInfoModal && !prevProps.isInfoModal) {
        this.infoModal.open();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        selectedFile = _this$props.selectedFile,
        selectedFolder = _this$props.selectedFolder,
        sortBy = _this$props.sortBy,
        filter = _this$props.filter,
        allowTts = _this$props.allowTts,
        ttsContent = _this$props.ttsContent;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-toolbar ".concat(_style["default"].toolbar)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames2["default"])('btn', 'btn-default', {
          active: this.props.viewMode === 'thumbnail'
        }),
        onClick: this.setViewMode.bind(null, 'thumbnail'),
        title: "Thumbnail view"
      }, /*#__PURE__*/_react["default"].createElement(_grid["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames2["default"])('btn', 'btn-default', {
          active: this.props.viewMode === 'list'
        }),
        onClick: this.setViewMode.bind(null, 'list'),
        title: "List view"
      }, /*#__PURE__*/_react["default"].createElement(_menu["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref) {
          var onClick = _ref.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-default",
            title: "Add folder",
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_folderPlus["default"], null));
        },
        title: "Add folder"
      }, /*#__PURE__*/_react["default"].createElement(_AddFolderForm["default"], null)), /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn btn-default",
        title: "Upload file",
        onClick: this.props.openFileDialog
      }, /*#__PURE__*/_react["default"].createElement(_filePlus["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref2) {
          var onClick = _ref2.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-default",
            title: "Rename",
            disabled: !selectedFile && !selectedFolder,
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null));
        },
        triggerDisabled: !selectedFile && !selectedFolder,
        title: "Rename"
      }, selectedFile ? /*#__PURE__*/_react["default"].createElement(_RenameFileForm["default"], null) : /*#__PURE__*/_react["default"].createElement(_RenameFolderForm["default"], null)), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref3) {
          var onClick = _ref3.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-default",
            title: "Move",
            disabled: !selectedFile && !selectedFolder,
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_fileUpload["default"], null));
        },
        triggerDisabled: !selectedFile && !selectedFolder,
        title: "Where to move?"
      }, /*#__PURE__*/_react["default"].createElement(_MoveForm["default"], null)), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger() {
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-default",
            title: "Info",
            disabled: !selectedFile && !selectedFolder,
            onClick: _this2.props.showInfoModal
          }, /*#__PURE__*/_react["default"].createElement(_info["default"], null));
        },
        triggerDisabled: !selectedFile && !selectedFolder,
        title: "Preview",
        size: "small",
        ref: function ref(elem) {
          _this2.infoModal = elem;
        },
        afterClose: function afterClose() {
          return _this2.props.showInfoModal(false);
        }
      }, /*#__PURE__*/_react["default"].createElement(_FileInfo["default"], null))), allowTts && /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        renderTrigger: function renderTrigger(_ref4) {
          var onClick = _ref4.onClick;
          return /*#__PURE__*/_react["default"].createElement("a", {
            className: "btn btn-default",
            title: "Generate Speech",
            onClick: onClick
          }, /*#__PURE__*/_react["default"].createElement(_mic["default"], null));
        },
        title: "Generate Speech"
      }, /*#__PURE__*/_react["default"].createElement(_GenerateSpeechForm["default"], {
        initialContent: ttsContent
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames2["default"])(_style["default"].filterBlock, _defineProperty({}, 'has-warning ' + _style["default"].isFilter, filter))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].search
      }, /*#__PURE__*/_react["default"].createElement(_search["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-control input-sm",
        type: "text",
        style: {
          width: '10em'
        },
        name: "filter",
        value: filter,
        onChange: this.setFilter,
        onKeyDown: this.onFilterKeyDown,
        placeholder: "Search"
      }), filter && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].cleanButton,
        onClick: function onClick() {
          return _this2.props.setFilter('');
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-remove text-warning"
      }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-control input-sm",
        style: {
          width: 'auto',
          marginLeft: '.5em'
        },
        value: sortBy,
        onChange: this.setSortBy,
        id: "sortBySelect"
      }, _assets.sortByOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: option.value,
          value: option.value
        }, option.label);
      })))));
    }
  }]);
  return Component;
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  viewMode: _propTypes["default"].string,
  sortBy: _propTypes["default"].string,
  filter: _propTypes["default"].string,
  setViewMode: _propTypes["default"].func,
  removeFile: _propTypes["default"].func,
  removeFolder: _propTypes["default"].func,
  setSortBy: _propTypes["default"].func,
  setFilter: _propTypes["default"].func,
  showInfoModal: _propTypes["default"].func,
  openFileDialog: _propTypes["default"].func,
  selectedFile: _propTypes["default"].object,
  selectedFolder: _propTypes["default"].object,
  isInfoModal: _propTypes["default"].bool,
  allowTts: _propTypes["default"].bool,
  ttsContent: _propTypes["default"].string
});
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    sortBy: state.resources.assets.sortBy,
    filter: state.resources.assets.filter,
    selectedFile: (0, _assets2.getOneSelectedFile)(state.resources.assets),
    selectedFolder: (0, _assets2.getOneSelectedFolder)(state.resources.assets),
    viewMode: state.resources.assets.viewMode,
    isInfoModal: state.resources.assets.isInfoModal
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, {
  setViewMode: _assets.setViewMode,
  removeFile: _assets.removeFile,
  removeFolder: _assets.removeFolder,
  setSortBy: _assets.setSortBy,
  setFilter: _assets.setFilter,
  showInfoModal: _assets.showInfoModal
})(Component);
exports["default"] = _default;